// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f8f8f8;
    border: none;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    min-height: 150px;
    box-sizing: border-box;
}

/* 기본 이미지 크기 제한 - 레이아웃 깨짐 방지 */
.image-placeholder img,
img[class*="image-"],
img[class*="item-image"],
img[class*="product-image"],
img[class*="confirm-item-image"],
img[class*="cart-item-image"],
img[class*="qd-product-image"],
img[class*="quotation-item-image"] {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    display: block;
}

/* 특정 페이지별 이미지 크기 설정 */
.item-image,
.quotation-item-image {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

.cart-item-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

.confirm-item-image {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

.product-image {
    width: 100px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

.qd-product-image {
    width: 80px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

/* 관리자 페이지 이미지 */
.admin-product-image,
.admin-quotation-image {
    width: 60px;
    height: 60px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
}

/* 메인 이미지 (상품 상세 페이지) */
.main-image {
    max-width: 400px;
    max-height: 400px;
    width: 100%;
    height: auto;
    object-fit: contain;
    border: 1px solid #eee;
    border-radius: 8px;
}

/* 썸네일 이미지 */
.thumbnail {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #eee;
    border-radius: 4px;
    cursor: pointer;
}

.thumbnail.active {
    border-color: #007bff;
    border-width: 2px;
}

/* 반응형 이미지 */
@media (max-width: 768px) {
    .main-image {
        max-width: 300px;
        max-height: 300px;
    }
    
    .product-image {
        width: 80px;
        height: 60px;
    }
    
    .item-image,
    .quotation-item-image {
        width: 60px;
        height: 45px;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/css/ImageWithPlaceholder.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA,8BAA8B;AAC9B;;;;;;;;IAQI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,sBAAsB;AACtB;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,gBAAgB;AAChB;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,YAAY;AACZ;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA,YAAY;AACZ;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;AACJ","sourcesContent":[".image-placeholder {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #f8f8f8;\n    border: none;\n    border-radius: inherit;\n    width: 100%;\n    height: 100%;\n    min-height: 150px;\n    box-sizing: border-box;\n}\n\n/* 기본 이미지 크기 제한 - 레이아웃 깨짐 방지 */\n.image-placeholder img,\nimg[class*=\"image-\"],\nimg[class*=\"item-image\"],\nimg[class*=\"product-image\"],\nimg[class*=\"confirm-item-image\"],\nimg[class*=\"cart-item-image\"],\nimg[class*=\"qd-product-image\"],\nimg[class*=\"quotation-item-image\"] {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: cover;\n    display: block;\n}\n\n/* 특정 페이지별 이미지 크기 설정 */\n.item-image,\n.quotation-item-image {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n.cart-item-image {\n    width: 60px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n.confirm-item-image {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n.product-image {\n    width: 100px;\n    height: 80px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n.qd-product-image {\n    width: 80px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n/* 관리자 페이지 이미지 */\n.admin-product-image,\n.admin-quotation-image {\n    width: 60px;\n    height: 60px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n}\n\n/* 메인 이미지 (상품 상세 페이지) */\n.main-image {\n    max-width: 400px;\n    max-height: 400px;\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    border: 1px solid #eee;\n    border-radius: 8px;\n}\n\n/* 썸네일 이미지 */\n.thumbnail {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    border: 1px solid #eee;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.thumbnail.active {\n    border-color: #007bff;\n    border-width: 2px;\n}\n\n/* 반응형 이미지 */\n@media (max-width: 768px) {\n    .main-image {\n        max-width: 300px;\n        max-height: 300px;\n    }\n    \n    .product-image {\n        width: 80px;\n        height: 60px;\n    }\n    \n    .item-image,\n    .quotation-item-image {\n        width: 60px;\n        height: 45px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
